import { render, staticRenderFns } from "./price_set.vue?vue&type=template&id=1bf13e31&scoped=true"
import script from "./price_set.vue?vue&type=script&lang=ts"
export * from "./price_set.vue?vue&type=script&lang=ts"
import style0 from "./price_set.vue?vue&type=style&index=0&id=1bf13e31&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bf13e31",
  null
  
)

export default component.exports